export default __webpack_public_path__ + "static/media/image-yx1-earphones.1e710ed3.jpg";